import { Text } from "@sitecore-jss/sitecore-jss-react";
import React, { FC, useEffect, useState } from "react";
import {
  StockPriceFeed,
  useStockPriceFeed,
} from "../../hooks/useStockPriceFeed";
import { ComponentProps, StringField } from "../../types/types";
import "./StockFeed.scss";

interface StockFeedProps extends ComponentProps {
  fields: {
    Comment: StringField;
    "NY Label": StringField;
    Title: StringField;
  };
}

interface MarketFeed {
  market: [StringField, string];
  data: StockPriceFeed;
}

const StockFeed: FC<StockFeedProps> = ({
  fields: { Title, "NY Label": NYLabel, Comment },
}) => {
  const stockPriceFeed = useStockPriceFeed();

  const MarketFeed: FC<MarketFeed> = ({ market, data }) => (
    <div className="StockFeed__market">
      <div className="StockFeed__market_name">
        <Text field={market[0]} />
      </div>
      <div className="StockFeed__market_feed_container">
        <h6>{market[1]}</h6>
        <p>{data.value}</p>
        <span className={data.uptrend ? "uptrend" : "downtrend"}>
          {data.change}
        </span>
      </div>
    </div>
  );

  const [display, setDisplay] = useState(false);
  useEffect(() => {
    if(stockPriceFeed && stockPriceFeed.NYSE && stockPriceFeed.NYSE.value && stockPriceFeed.NYSE.value.indexOf('undefined') == -1) {
      setDisplay(true);
    }
    else {
      setDisplay(false);
    }
  }, [stockPriceFeed]);

  return (
    <div className="StockFeed" style={{display: `${display == false ? 'none' : 'block'}`}}>
      <div className="StockFeed__container">
        <Text tag="h4" field={Title} />
        <MarketFeed
          market={[NYLabel, Object.keys(stockPriceFeed)[0]]}
          data={stockPriceFeed.NYSE}
        />
      </div>
      <div className="StockFeed__comment">
        <Text field={Comment} />
      </div>
    </div>
  );
};

export default StockFeed;
